export default "/images/globe.svg?3c2b6a912c89281b847419904b1f8e23";